import { Directive, HostBinding, Input, OnInit, ViewContainerRef, booleanAttribute } from '@angular/core';
import { Title } from '@angular/platform-browser';

const MAX_TITLE_CHECK_COUNT = 5;

@Directive({
  selector: 'glxy-page-title, [glxyPageTitle]',
})
export class PageTitleDirective implements OnInit {
  @HostBinding('class') class = 'glxy-page-title';

  /**
   * Updates the title of the tab based on the text contained within the title
   */
  @Input({ transform: booleanAttribute }) updateTabTitle = false;

  private checkCount = 0;

  constructor(
    private readonly title: Title,
    private readonly _viewContainerRef: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    if (this.updateTabTitle) {
      this.updateTitle();
    }
  }

  /**
   * Updates the title based on the content of the title container. If the content is empty
   * it will retry every 500ms for a limited amount of times.
   *
   * This would happen in the case of the translate pipe taking some time to translate text or
   * waiting for an observable, etc.
   */
  private updateTitle(): void {
    const titleText = this.getComponent().innerText || '';
    if (titleText.trim() !== '') {
      this.title.setTitle(titleText);
    } else {
      this.checkCount += 1;
      if (this.checkCount < MAX_TITLE_CHECK_COUNT) {
        window.setTimeout(() => this.updateTitle(), 500);
      }
    }
  }

  /**
   * Gets the reference the field itself
   */
  private getComponent(): HTMLElement {
    const container = (this._viewContainerRef as any)['_lContainer'][0];
    if (container instanceof HTMLElement) {
      return container;
    }

    const containerName = container.constructor.name;
    const componentName = containerName.split('_')[1];
    return container.filter((x: any) => x && x.constructor.name === componentName)[0];
  }
}
